export default __webpack_public_path__ + "static/media/banner_transparent_light.bef653e9.png";